import React, { useState, useRef, useEffect } from "react";
import { Link,useLocation,useParams} from "react-router-dom";
import { Pagination, EffectFade, Autoplay } from "swiper/modules"
import { useReactToPrint } from 'react-to-print';

import { useTranslation } from "react-i18next";

import VitalChart from '../components/charts';

import swal from 'sweetalert';

import Goodbtn from "../assets/good_btn.png";
import Normalbtn from "../assets/normal_btn.png";
import Badbtn from "../assets/bad_btn.png";

import SpinIcon from '../assets/spin_stress.gif';

import { Get, GetList, GetTime } from '../lib/DeviceData';

import SingleCare from "../assets/Nurion-logo.png";

import ttsAudio1 from "../assets/sound/tts_ok.mp3"; // 매우낮음
import ttsAudio2 from "../assets/sound/tts_error.mp3"; // 낮음


import ttsAudio_a from "../assets/sound/tts_10.mp3"; 
import ttsAudio_b from "../assets/sound/tts_11.mp3"; 
import ttsAudio_c from "../assets/sound/tts_12.mp3"; 




const Result = () => {
    const { t } = useTranslation();
    const componentRef1 = useRef(null);

    
    const audioRef = useRef(null);

    const [audioQueue, setAudioQueue] = useState([]);
    
    const ttsAudioList = [null, ttsAudio1,null,null,null, ttsAudio2];
    

    const followUpAudios = [ttsAudio_a, ttsAudio_b, ttsAudio_c];

    const [highlightIndex, setHighlightIndex] = useState(null);

    const location = useLocation();
    const userInfo = { ...location.state };

    
    const [bucketTime, setbucketTime] = useState('');
    const [HrTime, sethrTime] = useState(0);
    const [RrTime, setrrTime] = useState(0);

    const [RMSSD_set, setrmssd] = useState(0.0);
    const [SDNN_set, setsdnn] = useState(0.0);
    const [pNN50_set, setpnn50] = useState(0.0);

    const [baevsky_si_set, setbaevsky] = useState(0.0);

    const [Stress_LV, setstresslevel] = useState(0.0);
    const [Stress_LV_TEXT, setstresslevel_text] = useState('');

    const [device_sn, SetDevice_sn] = useState(0);
    const [device_no, SetDevice_no] = useState(0);
    const [member_no, SetMemeber_no] = useState(0);
    const [member_id, SetId] = useState('');
    const [name, SetName] = useState('');
    const [sex, SetSex] = useState(0);
    const [birth, SetBirth] = useState(0);
    const [feel, SetFeel] = useState('');
    const [status, SetStatus] = useState('');

    const [hr_level, sethr_level] = useState([]);
    const [rr_level, setrr_level] = useState([]);
    const [time_level, settime_level] = useState([]);

    useEffect(() => {
        if (Stress_LV >= 1 && Stress_LV <= 5) {
            const initial = ttsAudioList[Stress_LV];
            setAudioQueue(initial); 
        }
    }, [Stress_LV]);





    useEffect(()=> {
        fetchData();
    }, []);

    const fetchData = () => {

        try {

            const data = userInfo;


            sethrTime(Math.round(data.hr));
            setrrTime(Math.round(data.rr));
            setbucketTime(data.date);

            SetDevice_sn(data.device_sn);
            SetDevice_no(data.device_no);
            SetMemeber_no(data.member_no);
            SetName(data.name);
            SetId(data.member_id);
            SetSex(data.sex);
            SetBirth(data.birth);
            
            const result_data = JSON.parse(data.result_data);


            var array_hr=[];
            var array_rr=[];
            var array_time=[];

            var k=10;

            if(result_data.length>11){

                for (let i = result_data.length - 1; i >= 0; i--) {
                    array_hr.push(result_data[i].heart);
                    array_rr.push(result_data[i].resp);
                    array_time.push(k+"초");
                    k--;

                    if(k==0){ break; }
                }

            }

            sethr_level(array_hr);
            setrr_level(array_rr);
            settime_level(array_time);

            let hr_abnormal_count = 0;
            let rr_abnormal_count = 0;

             for (let i = 0; i < array_hr.length; i++) {
                if (array_hr[i] < 60 || array_hr[i] > 100) hr_abnormal_count++;
                if (array_rr[i] < 10 || array_rr[i] > 22) rr_abnormal_count++;
            }
            
            const total_abnormal = hr_abnormal_count + rr_abnormal_count;

            if(Math.round(data.hr)>=51 && Math.round(data.hr)<=110){
                SetStatus("정상");
                setstresslevel(1);
            }else{
                SetStatus("이상");
                setstresslevel(5);
            }

            if(Math.round(data.rr)>=9 && Math.round(data.rr)<=24){
                SetStatus("정상");
                setstresslevel(1);
            }else{
                SetStatus("이상");
                setstresslevel(5);
            }

           /* if (total_abnormal >= 4) {
                SetStatus("이상");
                setstresslevel(5);
            } else {
                SetStatus("정상");
                setstresslevel(1);
            }*/
/*
            setrmssd(parseFloat(Number(data.rmssd).toFixed(1)));
            setsdnn(parseFloat(Number(data.sdnn).toFixed(1)));
            setpnn50(parseFloat(Number(data.pnn50).toFixed(1)));
            setbaevsky(data.baevsky_si);

            if(Math.round(Number(data.rmssd))<=20){
                setrmssd_level(1);
            }else if(Math.round(Number(data.rmssd))>20 && Math.round(Number(data.rmssd))<80){
                setrmssd_level(2);
            }else{
                setrmssd_level(3);
            }



            if(Math.round(Number(data.sdnn))<=30){
                setsdnn_level(1);
            }else if(Math.round(Number(data.sdnn))>30 && Math.round(Number(data.sdnn))<100){
                setsdnn_level(2);
            }else{
                setsdnn_level(3);
            }

            if(Math.round(Number(data.pnn50))<=20){
                setpnn50_level(1);
            }else{
                setpnn50_level(2);
            }




            if(Number(data.baevsky_si) <= 100){
                setstresslevel(1);
                setstresslevel_text("매우낮음");
            }else if(Number(data.baevsky_si) <= 300){
                setstresslevel(2);
                setstresslevel_text("낮음");
            }else if(Number(data.baevsky_si) <= 500){
                setstresslevel(3);
                setstresslevel_text("적정");
            }else if(Number(data.baevsky_si) <= 700){
                setstresslevel(4);
                setstresslevel_text("높음");
            }else{
                setstresslevel(5);
                setstresslevel_text("매우높음");
            }*/

            // 100 미만: 최적의 적응, 낮은 스트레스.
            // 100-300: 정상적인 적응, 가벼운 스트레스.
            // 300-500: 보통 스트레스, 조절 시스템의 긴장.
            // 500-700: 현저한 스트레스, 조절 시스템의 상당한 긴장, 과로 가능성.
            // 700 초과: 심각한 스트레스, 적응 메커니즘의 붕괴, 병리학적 위험 높음.


        } catch (error) {
            console.log("Error fetching data:", error);
        }
    }

    
    const styles = {
    	textAlign:"left",
        width: "55%",
    }

    const handlePrint = useReactToPrint({
        contentRef: componentRef1,
        documentTitle: "측정리포트" ,
        pageStyle: "@page { size: A4; ratio:65%;margin:10; }body {-webkit-print-color-adjust: exact;}" 
    });


    return (
        <main className="main-container">
            
            <audio ref={audioRef} src={ttsAudioList[Stress_LV]} autoPlay />

            <div className="report_area" ref={componentRef1}>
                <div className="top_area">
                    <img src={SingleCare} className="top_logo_report" />
                    <h2>
                        누리온 헬스케어 측정 리포트
                    </h2>
                </div>
                <div className="desc_area">
                    <table>
                        <thead>
                            <tr>
                                <th>성명</th>
                                <th>성별</th>
                                <th>생년월일</th>
                                <th>측정일</th>
                                <th>식별번호</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{name}</td>
                                <td>
                                    {
                                        {
                                        'male': "남성",
                                        'female': "여성",
                                        }[sex]
                                    }
                                </td>
                                <td>{birth}</td>
                                <td>{bucketTime}</td>
                                <td>{member_id}</td>
                            </tr>
                        </tbody>
                    </table>

                    <div className="flex_area">
                        <div className="w50 left">
                            <ul>
                                <li>
                                    <h3>평균 맥박수(HR)</h3>
                                    <span><i style={{color:"#ED4D4D"}}>{HrTime}</i> BPM</span>
                                </li>
                                <li>
                                    <h3>평균 호흡수(RR)</h3>
                                    <span><i style={{color:"#347deb"}}>{RrTime}</i> BPM</span>
                                </li>
                            </ul>
                        </div>
                        <div className="w50 right">
                            <h3 className="title">측정 결과</h3>
                            <div className="progress_level">
                                <div className="progress">
                                    <div className={`level_icon level${Stress_LV}`}></div>
                                </div>
                                <div className="level_text">
                                    <div className="level_text_area">정상</div>

                                    <div className="level_text_area">이상</div>
                                </div>
                            </div>

                            <div className="Stress_level">
                                <h2>{status}</h2>
                            </div>
                        </div>
                    </div>

                    <div className="stress_area">
                        <div className="doc-root">
                            <VitalChart array_time={time_level} array_hr={hr_level} array_rr={rr_level} />
                        </div>
                    </div>

                    <div className="HRV_graph">
                        <p>
                            <b>HR 맥박수</b> (분당 60 ~ 100 회 정상):<br />성인 기준으로 안정 시 정상 맥박수 범위는 일반적으로 분당 60~100회입니다. 하지만, 개인의 신체 상태나 활동 수준에 따라 달라질 수 있으며, 운동선수처럼 훈련된 사람은 더 낮은 맥박수를 보일 수 있습니다. 
                        </p>
                        <p style={{marginBottom : 0}}>
                            <b>RR 호흡수</b> (분당 12 ~ 20 회 정상):<br />성인의 정상 호흡수 범위는 일반적으로 분당 12~20회입니다. 이는 휴식 시 호흡수를 기준으로 합니다. 
                        </p>
                    </div>
                </div>

                <p className="bottom_text">(알림) 이 리포트는 누리온 헬스케어 키오스크로 측정한 생체 신호를 분석한 개인 건강 관리용 정보입니다. 해당 키오스크는 의료기기가 아니므로, 이 정보를 질병의 진단, 치료, 예방 등의 의료 목적으로 사용하지 마세요. 건강 상태를 참고하는 용도로만 활용하시기 바랍니다.</p>
            </div>

            <button className="print_ico" onClick={() => handlePrint()}>인쇄하기</button>
        </main>
    );
};

export default Result;
